import { Box } from '@chakra-ui/react';
import { selectHasShowGrid } from 'modules/Editor/store/editorSettingsSelector';
import { useAppSelector } from 'modules/Editor/store/hooks';
import { memo } from 'react';
import { PageBackgroundData } from 'types/pageTypes';
import { isLight } from 'utils/color';

const CELL_SIZE = '20px';

interface GridOverlayProps {
  pageBackground: PageBackgroundData;
  hasLargeLineSize: boolean;
}

export const GridOverlay = memo(({ pageBackground, hasLargeLineSize }: GridOverlayProps) => {
  const hasShowGrid = useAppSelector(selectHasShowGrid);
  if (!hasShowGrid) return null;

  const lineSize = hasLargeLineSize ? 2 : 1;

  const { background, gradientBackground } = pageBackground;
  const pageColor = gradientBackground ? gradientBackground.colors[0] : background;
  const lineColor = isLight(pageColor) ? '#123' : '#fff';

  const gridGradient = `
    repeating-linear-gradient(0deg, ${lineColor}, ${lineColor},
    transparent ${lineSize}px, transparent ${CELL_SIZE}),
    repeating-linear-gradient(-90deg, ${lineColor},
    ${lineColor}, transparent ${lineSize}px, transparent ${CELL_SIZE})`;

  return (
    <Box
      zIndex='gridLines'
      data-testid='grid-overlay-container'
      pointerEvents='none'
      position='absolute'
      w='full'
      h='full'
      opacity='0.15'
      backgroundImage={gridGradient}
      backgroundSize={`${CELL_SIZE} ${CELL_SIZE}`}
    />
  );
});
GridOverlay.displayName = 'GridOverlay';
